export { default as SegmentedControl } from './SegmentedControl';